import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Button } from 'react-bootstrap'

import * as actions from '../../../actions'
import { FORM_REIMPRESION_COMPROBANTE } from '../../../../../config/forms'
import CamposReimpresionComprobante1 from
  '../../../components/reimpresionComprobante/CamposReimpresionComprobante1'

class ReimpresionComprobante1 extends Component {
  componentDidMount () {
    const {
      impresora,
      cpa,
      imprimirEtiquetaIngreso
    } = this.props
    imprimirEtiquetaIngreso(cpa.numero, impresora, true)
  }

  render () {
    const {
      onSubmit,
      onPrev,
      cpa
    } = this.props

    return (
      <div>
        <h3>Impresión de comprobante</h3>
        <br />
        <hr />
        <CamposReimpresionComprobante1 formValues={cpa} />
        <hr />
        <br />
        <Button
          type='button'
          onClick={() => onPrev()}
          size='lg'
          variant='primary'
        >Atras</Button>
        {' '}
        <Button
          type='submit'
          onClick={() => onSubmit()}
          size='lg'
          variant='primary'
        >Finalizar</Button>
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  formValues: getFormValues(FORM_REIMPRESION_COMPROBANTE)(state),
  impresora: state.camionesIngreso.iCompletoImpresora,
  cpa: state.camionesIngreso.consultaCpa
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_REIMPRESION_COMPROBANTE,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})

export default withRedux(withReduxForm(ReimpresionComprobante1))
